import { useState } from "react";
import { auth } from "../firebase";

const API_BASE =
  "https://us-central1-my-firstproject-350605-a54a7.cloudfunctions.net";

export default function MFA({ onSetupComplete }) {
  const [qr, setQr] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("User not logged in");
        return;
      }

      setGenerating(true);
      const token = await user.getIdToken(true);

      const res = await fetch(`${API_BASE}/generateMfaSecret`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (!data.success || !data.qrCode) {
        alert(data.error || "Failed to generate QR code");
        return;
      }

      setQr(data.qrCode);
    } catch (err) {
      console.error("Generate MFA failed:", err);
      alert("Error generating QR code");
    } finally {
      setGenerating(false);
    }
  };

  const handleVerify = async () => {
    try {
      if (!code || code.length !== 6) {
        alert("Enter the 6-digit code from your authenticator app");
        return;
      }

      const user = auth.currentUser;
      if (!user) {
        alert("User not logged in");
        return;
      }

      setLoading(true);
      const token = await user.getIdToken(true);

      const res = await fetch(`${API_BASE}/verifyMfaCode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ token: code }),
      });

      const data = await res.json();

      if (!data.success) {
        alert(data.error || "Invalid code");
        return;
      }

      localStorage.setItem("mfa_verified", "true");
      localStorage.setItem("mfa_verified_uid", user.uid);

      alert("MFA enabled successfully ✅");
      if (typeof onSetupComplete === "function") {
        onSetupComplete();
      }
    } catch (err) {
      console.error("Verify MFA failed:", err);
      alert("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(37,99,235,0.16), transparent 32%), #020617",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "#0f172a",
          border: "1px solid rgba(148,163,184,0.18)",
          padding: 32,
          borderRadius: 20,
          width: 430,
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
        }}
      >
        <h2 style={{ margin: "0 0 10px" }}>📱 Set Up Multi-Factor Authentication</h2>
        <p style={{ color: "#94a3b8", lineHeight: 1.6, marginBottom: 22 }}>
          First-time security setup. Scan the QR code using <b>Google Authenticator</b> or{" "}
          <b>Microsoft Authenticator</b>, then enter the 6-digit code.
        </p>

        {!qr && (
          <button
            onClick={handleGenerate}
            disabled={generating}
            style={{
              padding: 14,
              width: "100%",
              background: "#2563eb",
              color: "white",
              border: "none",
              borderRadius: 12,
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            {generating ? "Generating QR..." : "Generate QR Code"}
          </button>
        )}

        {qr && (
          <>
            <div
              style={{
                background: "white",
                padding: 14,
                borderRadius: 16,
                margin: "20px auto",
                width: 240,
              }}
            >
              <img src={qr} alt="MFA QR Code" style={{ width: 212, display: "block" }} />
            </div>

            <input
              value={code}
              maxLength={6}
              onChange={(e) =>
                setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
              }
              placeholder="123456"
              style={{
                boxSizing: "border-box",
                width: "100%",
                padding: 14,
                textAlign: "center",
                fontSize: 22,
                letterSpacing: 6,
                borderRadius: 12,
                border: "1px solid #334155",
                background: "#020617",
                color: "white",
              }}
            />

            <button
              onClick={handleVerify}
              disabled={loading}
              style={{
                marginTop: 16,
                padding: 14,
                width: "100%",
                background: "#22c55e",
                color: "white",
                border: "none",
                borderRadius: 12,
                fontWeight: 900,
                cursor: "pointer",
              }}
            >
              {loading ? "Verifying..." : "Verify & Activate"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
